import {SmileyIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import {Tooltip} from '@primer/react/deprecated'

import {VALUES} from '../constants/values'
import styles from './ReactionViewerAnchor.module.css'

type RenderAnchorProps = React.HTMLAttributes<HTMLElement>
type ReactionViewerAnchorProps = {
  renderAnchorProps?: RenderAnchorProps
  reactionsAvailable?: boolean
}

export function ReactionViewerAnchor({renderAnchorProps, reactionsAvailable}: ReactionViewerAnchorProps) {
  const iconButton = <BaseIcon renderAnchorProps={renderAnchorProps} reactionsAvailable={reactionsAvailable} />

  return reactionsAvailable ? iconButton : <Tooltip aria-label={VALUES.reactionsUnavailable}>{iconButton}</Tooltip>
}

const BaseIcon = ({renderAnchorProps, reactionsAvailable}: ReactionViewerAnchorProps) => (
  // eslint-disable-next-line primer-react/a11y-remove-disable-tooltip
  <IconButton
    unsafeDisableTooltip
    size="small"
    icon={SmileyIcon}
    {...renderAnchorProps}
    aria-label={VALUES.addOrRemoveReaction}
    inactive={!reactionsAvailable}
    aria-labelledby={undefined}
    className={styles.ReactionViewerAnchorButton}
  />
)

try{ ReactionViewerAnchor.displayName ||= 'ReactionViewerAnchor' } catch {}
try{ BaseIcon.displayName ||= 'BaseIcon' } catch {}